var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"red-num",staticClass:"cpt-red-num-wrapper",style:(_vm.style)},[_c('span',{staticClass:"red-num",class:{
      border: _vm.isHasBorder || _vm.borderColor
    },style:({
      'border-color': _vm.borderColor || ''
    })},[_vm._v(" "+_vm._s(_vm.num > 99 ? '99+' : _vm.num)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }